(function(root, factory) {
  const api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (typeof window !== "undefined") window.WTEIngredientCosting = api;
})(typeof globalThis !== "undefined" ? globalThis : this, function() {
  "use strict";
  const round = (value) => Math.round(value * 100) / 100;

  function packageCost(pack, currency) {
    if (!pack || pack.currency !== currency || !Number.isFinite(pack.size) || pack.size <= 0 ||
        !Number.isFinite(pack.price) || pack.price < 0 || !Number.isFinite(pack.yieldPercent) ||
        pack.yieldPercent <= 0 || pack.yieldPercent > 100) return null;
    const usable = pack.size * pack.yieldPercent / 100;
    return { usable, unitCost: pack.price / usable };
  }

  function costLines(lines, ingredients, currency) {
    const missing = [];
    let total = 0;
    const rows = lines.map((line) => {
      const ingredient = ingredients.find((row) => row.id === line.ingredientId);
      const pack = ingredient && packageCost(ingredient.package, currency);
      if (!pack || ingredient.unit !== line.unit) missing.push(ingredient ? ingredient.name : line.ingredientId);
      const cost = pack ? line.quantity * pack.unitCost : null;
      if (cost !== null) total += cost;
      return { ...line, name: ingredient ? ingredient.name : line.ingredientId,
        unitCost: pack ? pack.unitCost : null, cost: cost === null ? null : round(cost),
        servingsPerPackage: pack ? Math.floor(pack.usable / line.quantity) : null };
    });
    return { rows, total: missing.length ? null : round(total), missing };
  }

  function estimate(recipe, ingredients, currency, portion, extras, packaging, price, target) {
    if (!recipe) return { error: "Recipe quantities not recorded." };
    const selected = [...recipe.base];
    const sections = [recipe.base];
    const adjustment = recipe.portions.find((row) => row.key === portion);
    if (adjustment) {
      selected.push(...adjustment.lines);
      sections.push(adjustment.lines);
    }
    else if (portion !== "Regular") return { error: `Portion quantities not recorded: ${portion}.` };
    for (const key of extras) {
      const extra = recipe.extras.find((row) => row.key === key);
      if (!extra) return { error: `Add-on quantities not recorded: ${key}.` };
      selected.push(...extra.lines);
      sections.push(extra.lines);
    }
    const grouped = new Map();
    for (const line of selected) {
      const existing = grouped.get(line.ingredientId);
      if (existing) existing.quantity += line.quantity;
      else grouped.set(line.ingredientId, { ...line });
    }
    const ingredientsCost = costLines(Array.from(grouped.values()), ingredients, currency);
    if (ingredientsCost.total === null) return { ...ingredientsCost, error: `Package cost not recorded in ${currency}: ${ingredientsCost.missing.join(", ")}.` };
    // Match the independently rounded base/option costs saved for order snapshots.
    ingredientsCost.total = round(sections.reduce((sum, rows) => sum + costLines(rows, ingredients, currency).total, 0));
    if (!Number.isFinite(packaging) || packaging < 0 || packaging > 100000) {
      return { ...ingredientsCost, error: "Enter a valid packaging cost, including explicit zero." };
    }
    if (!Number.isFinite(price) || price < 0) return { ...ingredientsCost, error: "Enter a valid meal selling price." };
    if (!Number.isFinite(target) || target < 0 || target >= 100) {
      return { ...ingredientsCost, error: "Target gross margin must be at least 0% and below 100%." };
    }
    const total = round(ingredientsCost.total + packaging);
    // Round upwards to avoid recommending a price below the requested margin.
    const suggested = Math.ceil((total / (1 - target / 100) - 1e-9) * 100) / 100;
    const profit = round(price - total);
    return { ...ingredientsCost, ingredientCost: ingredientsCost.total, totalCost: total, profit,
      margin: price > 0 ? 100 * profit / price : null, suggestedPrice: suggested };
  }
  return { packageCost, costLines, estimate };
});
